<template>

    <div>

        <el-row class="mb-3" v-if="terapistas.length > 0">
            <el-col :span="24">
                <p class="comfy-text s-16 mb-0">Usa el <b>desplegable</b> ó las <b>flechas</b> del carrusel para ubicar al PRO de tu preferencia y selecciona haciendo clic sobre su nombre</p>
            </el-col>
        </el-row>

        <el-row class="mb-3" v-if="terapistas.length > 0">
            <el-col :span="24">
                <el-select class="w-100" v-model="select_terapeuta" filterable placeholder="Selecciona tu terapeuta" size="large">
                    <el-option v-for="terapista in terapistas" :key="terapista.id" :label="terapista.nombre" :value="terapista.id">
                    </el-option>
                </el-select>
            </el-col>
        </el-row>   

        <el-carousel v-if="terapistas.length > 0" indicator-position="none" :autoplay="false" trigger="click" height="260px" arrow="always">
            <el-carousel-item v-for="terapista in terapistas" :key="terapista.id">
                <el-row type="flex" justify="center">
                    <el-col :span="20">
                        <el-row class="d-flex align-items-center flex-column">
                            <el-button class="perfilProBoton s-14" type="primary" size="small" @click="openProfile(terapista.id)" v-if="showPerfil">
                                Ver<br>perfil
                            </el-button>
                            <el-avatar shape="circle" :size="260" fit="fill" :src="url + terapista.foto" @error="errorHandler"></el-avatar>
                            <el-button class="elegirMasajistaBoton" type="primary" size="small" @click="masajistaUnoSeleccionada(terapista)">
                                {{ terapista.nombre }}
                                <span class="d-block s-10 mt-1">seleccionar</span>
                            </el-button>
                        </el-row>
                    </el-col>
                </el-row>
            </el-carousel-item>
        </el-carousel>

        <el-row v-if="servicio.terapistaUno.id" class="mb-3">
            <el-col :xs="5" :sm="5">
                <vs-avatar size="60" circle history history-gradient>
                    <img :src="url + servicio.terapistaUno.foto" alt="">
                    <template #badge v-if="showPerfil">
                        <span @click="openProfile(servicio.terapistaUno.id)" class="cursor-pointer">
                            Ver perfil
                        </span>
                    </template>
                </vs-avatar>
            </el-col>
            <el-col :xs="19" :sm="19">
                Has seleccionado a la terapista <b>{{ servicio.terapistaUno.nombre }}</b>, elige una fecha para poder reservar un servicio con ella o haz clic aquí para <a href="#" @click.prevent="cambiarTerapistaUno">cambiar de terapeuta</a>.
            </el-col>
        </el-row>

        <el-row v-if="servicio.terapistaUno.id" class="mb-3">
            <el-col :span="24">
                <p class="mb-1 comfy-text">Elige la duración de tu servicio:</p>
                <el-radio-group v-model="servicio.duracion" class="w-100">
                    <el-radio-button label="60" class="w-33">
                        <p class="font-weight-bold comfy-second-text mb-0 s-36 ivy-bold">60<span class="d-block grey-text s-10 font-weight-normal">Minutos</span></p>
                    </el-radio-button>
                    <el-radio-button label="90" v-if="servicio.tipo != 'btb' && servicio.terapistaUno.duration >= 90" class="w-33">
                        <p class="font-weight-bold comfy-second-text mb-0 s-36 ivy-bold">90<span class="d-block grey-text s-10 font-weight-normal">Minutos</span></p>
                    </el-radio-button>
                    <el-radio-button label="120" v-if="servicio.tipo != 'btb' && servicio.terapistaUno.duration >= 120" class="w-33">
                        <p class="font-weight-bold comfy-second-text mb-0 s-36 ivy-bold">120<span class="d-block grey-text s-10 font-weight-normal">Minutos</span></p>
                    </el-radio-button>
                </el-radio-group>
            </el-col>
        </el-row>

        <el-row class="mb-3" v-if="servicio.duracion">
            <el-col :span="24">
                <p class="mb-1 comfy-text">Elige el masaje de tu preferencia:</p>
                <el-select v-model="servicio.masaje_uno" clearable placeholder="Selecciona tu masaje" size="large" class="w-100">
                    <el-option
                        v-for="item in servicio.terapistaUno.massagestype" :key="item.id"
                        :label="item.nombre"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-col>
        </el-row>

        <el-row class="mb-3" v-if="servicio.masaje_uno && servicio.tipo == 'btb'">
            <el-col :span="24">
                <p class="mb-1 comfy-text">Elige el segundo masaje:</p>
                <el-select v-model="servicio.masaje_dos" clearable placeholder="Selecciona tu masaje" size="large" class="w-100">
                    <el-option
                        v-for="item in servicio.terapistaUno.massagestype" :key="item.id"
                        :label="item.nombre"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-col>
        </el-row>

        <el-row v-if="selectDateTimeOne" class="mb-3" :gutter="10">
            <el-col :span="24">
                <p class="mb-1 comfy-text">Elige fecha y hora para tu reserva:</p>
            </el-col>
            <el-col :span="12">
                <el-date-picker
                    v-model="servicio.fecha"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="Elige el día"
                    :picker-options="pickerOptions">
                </el-date-picker>
            </el-col>
            <el-col :span="12" v-if="servicio.fecha">
                <el-select v-model="servicio.hora" clearable placeholder="Elige una hora" size="large" class="w-100">
                    <el-option
                        v-for="item in horarioTerapistaUno" :key="item.index"
                        :label="item"
                        :value="item">
                    </el-option>
                </el-select>
            </el-col>
        </el-row>

        <el-row class="mb-3" v-if="error">
			<el-col :span="24">
				<div class="font-weight-normal text-danger">
					<p>
						<span v-text="errores"></span> <a v-if="buttonurl" class="text-success text-decoration-underline" target="_blank" :href="buttonurl" v-text="textbutton"></a>
					</p>
				</div>
			</el-col>
		</el-row>

    </div>

</template>

<script>

    export default {
        props: [
            'servicio'
        ],
        data() {
            return {
                url: 'https://ivo-comfy.s3.amazonaws.com/',
				error: false,
				errores: '',
				textbutton: '',
				buttonurl: '',
                terapistas: '',
                terapistasDoble: '',
                pickerOptions: {
                    disabledDate: this.disabledDate,
                },
                disponibilidadTerapistaUno: '',
                horarioTerapistaUno: '',
                masajesTerapistaDos: [],
                confirmarProceso: false,
                select_terapeuta: '',
                showPerfil: true,
            }
        },
        computed: {
            selectDateTimeOne(){
                if(this.servicio.tipo == 'btb'){
                    if(this.servicio.masaje_dos){
                        return true
                    }
                }else if(this.servicio.tipo != 'btb' && this.servicio.masaje_uno){
                    return true
                }else{
                    return false
                }
            }
        },
        watch: {
            'servicio.duracion': function(val){
                this.servicio.masaje_uno = ''
                if(this.servicio.tipo == 'doble'){
                    this.servicio.masaje_dos = ''
                    this.servicio.terapistaDos = ''
                    this.masajesTerapistaDos = ''
                    this.terapistasDoble = ''
                }
                this.servicio.fecha = ''
                this.servicio.hora = ''
            },
            'servicio.masaje_uno': function(val){
                if(this.servicio.tipo != 'doble'){
                    this.servicio.fecha = ''
                    this.servicio.masaje_dos = ''
                }
            },
            'servicio.masaje_dos': function(val){
                if(this.servicio.tipo != 'doble'){
                    this.servicio.fecha = ''
                }else {
                    this.precioMasajistaUno()
                }
            },
            'servicio.fecha': function(val){
                if(this.servicio.tipo == 'doble'){
                    this.servicio.masaje_dos = ''
                    this.servicio.terapistaDos = ''
                    this.masajesTerapistaDos = ''
                    this.terapistasDoble = ''
                }
                this.servicio.hora = ''
                if(val){
                    // console.log(val)
                    if(!this.servicio.fecha){
                        return
                    }
                    if(!this.servicio.masaje_uno){
                        return
                    }
                    if(!this.servicio.duracion){
                        return
                    }
                    if(!this.servicio.terapistaUno){
                        return
                    }
                    let terapista = this.servicio.terapistaUno.id
                    this.horarioMasajistaUno(terapista)
                }
            },
            'servicio.hora': function(val){
                if(this.servicio.tipo == 'doble'){
                    this.servicio.masaje_dos = ''
                    this.servicio.terapistaDos = ''
                    this.masajesTerapistaDos = ''
                    this.terapistasDoble = ''
                }
                if(!this.servicio.ciudad){
                    return
                }
                if(!this.servicio.datosDireccion.direccion){
                    return
                }
                if(!this.servicio.fecha){
                    return
                }
                if(!this.servicio.hora){
                    return
                }
                if(!this.servicio.masaje_uno){
                    return
                }
                if(!this.servicio.terapistaUno){
                    return
                }
                if(this.servicio.tipo == 'btb'){
                    if(!this.servicio.masaje_dos){
                        return
                    }
                }
                this.precioMasajistaUno()
            },
            'confirmarProceso': function(val){
                EventBus.$emit('confirmarPasoDosFecha', val)
            },
            'select_terapeuta': function(val){
                var terapeuta_seleccionada = this.terapistas.find(terapista => terapista.id === val)
                this.masajistaUnoSeleccionada(terapeuta_seleccionada)
            }
        },
        methods: {
            errorHandler() {
                return true
            },
            disabledDate(time){
                const disponible = this.disponibilidadTerapistaUno
                // const disponible = ['2021-03-10', '2021-03-20', '2021-03-30', '2021-04-05']
                const year = time.getFullYear()
                const mouth = time.getMonth() + 1
                const date = time.getDate()
                const dateString = `${year}-${mouth > 9 ? mouth : '0' + mouth}-${date > 9 ? date : '0' + date}`
                const availableDates = disponible.includes(dateString)
                // const days = 60 * 24 * 3600 * 1000
                // const calendar = time.getTime() < Date.now() - 8.64e7 || time.getTime() > Date.now() + days || availableDates
                return !availableDates
            },
            cambiarTerapistaUno(){
                this.servicio.terapistaUno = ''
                this.servicio.terapistaDos = ''
                this.servicio.fecha = ''
                this.servicio.hora = ''
                this.servicio.duracion = ''
                this.servicio.masaje_uno = ''
                this.servicio.masaje_dos = ''
                this.disponibilidadTerapistaUno = ''
                this.masajistasDisponibles()
            },
            cambiarTerapistaDos(){
                this.servicio.masaje_dos = ''
                this.servicio.terapistaDos = ''
                this.masajesTerapistaDos = ''
                this.masajistasDisponiblesDoble()
            },
            masajistasDisponibles(){
                this.error = false
                this.errores = ''
                this.buttonurl = ''
                this.textbutton = ''
                var url = '/cliente/servicio/buscar-manual'
                axios.post(url, {
                    'city_id': this.servicio.ciudad,
                    'direccion': this.servicio.datosDireccion.direccion,
                    'genero': this.servicio.genero,
                }).then(response => {
                    if(response.data.code == 200){
                        this.terapistas = response.data.terapistas
                    }
                    if(response.data.code == 400){
                        this.error = true
                        this.errores = response.data.error
                        this.buttonurl = response.data.buttonurl
                        this.textbutton = response.data.textbutton
                    }
                })
            },
            masajistaUnoSeleccionada(terapista){
                // console.log('--- buscar fechas disponibles de terapista uno, personal ---')
                // console.log(terapista)
                this.error = false
                this.errores = ''
                this.buttonurl = ''
                this.textbutton = ''
                this.$message({
                    message: 'Has seleccionado la terapeuta ' + terapista.nombre + ' para tu masaje',
                    type: 'success'
                });
                var url = '/cliente/servicio/disponibilidad-manual-terapista'
                axios.post(url, {
                    'terapista': terapista.id,
                    'direccion': this.servicio.datosDireccion.direccion
                }).then(response => {
                    if(response.data.code == 200){
                        this.disponibilidadTerapistaUno = response.data.disponibilidad
                    }
                    if(response.data.code == 400){
                        this.error = true
                        this.errores = response.data.error
                        this.buttonurl = response.data.buttonurl
                        this.textbutton = response.data.textbutton
                    }
                })
                this.servicio.terapistaUno = terapista
                if(this.servicio.tipo == 'btb'){
                    this.servicio.terapistaDos = terapista
                }
                this.terapistas = []
            },
            masajistaDosSeleccionada(terapista){
                // console.log('--- buscar disponibilidad de terapista dos ---')
                this.error = false
                this.errores = ''
                this.buttonurl = ''
                this.textbutton = ''
                this.$message({
                    message: 'Has seleccionado la terapeuta ' + terapista.nombre + ' para tu masaje',
                    type: 'success'
                });
                // console.log(terapista)
                this.servicio.terapistaDos = terapista
                this.servicio.desplazamientoDos = terapista.desplazamiento
                this.masajesTerapistaDos = terapista.massagestype
                this.terapistasDoble = ''
                return;
            },
            horarioMasajistaUno(terapista){
                // console.log('--- buscar horario disponible terapeuta uno ---')
                this.error = false
                this.errores = ''
                this.buttonurl = ''
                this.textbutton = ''
                var url = '/cliente/servicio/disponibilidad-horario-terapista'
                axios.post(url, {
                    'terapista': terapista,
                    'fecha': this.servicio.fecha,
                    'duracion': this.servicio.duracion,
                    'tipo': this.servicio.tipo
                }).then(response => {
                    // console.log(response.data)
                    if(response.data.code == 200){
                        this.horarioTerapistaUno = response.data.horario
                    }
                })
            },
            precioMasajistaUno(){
                this.servicio.desplazamientoUno = 0
                this.servicio.masajeUnoValor = 0
                this.servicio.tarifaDinamicaUno = 0
                this.servicio.masajeDosValor = 0
                this.servicio.tarifaDinamicaDos = 0
                this.servicio.desplazamientoDos = 0
                this.confirmarProceso = false
                // console.log('--- calculando precio de servicio terapista con distancia ---')
                this.error = false
                this.errores = ''
                this.buttonurl = ''
                this.textbutton = ''
                var url = '/cliente/servicio/disponibilidad-manual-terapista-precio'
                axios.post(url, {
                    'ciudad': this.servicio.ciudad,
                    'direccion': this.servicio.datosDireccion.direccion,
                    'duracion': this.servicio.duracion,
                    'terapista_uno': this.servicio.terapistaUno.id,
                    'terapista_dos': (this.servicio.terapistaDos) ? this.servicio.terapistaDos.id : null,
                    'tipo': this.servicio.tipo,
                    'masaje_uno': this.servicio.masaje_uno,
                    'masaje_dos': this.servicio.masaje_dos,
                    'fecha': this.servicio.fecha,
                    'hora': this.servicio.hora
                }).then(response => {
                    // console.log(response.data)
                    if(response.data.code == 200){
                        // console.log(response.data)
                        this.servicio.desplazamientoUno = response.data.desgloce.desplazamientoUno
                        this.servicio.masajeUnoValor = response.data.desgloce.precioMasajeUno
                        this.servicio.tarifaDinamicaUno = response.data.desgloce.precioDinamicaUno
                        if(response.data.desgloce.precioMasajeDos){
                            this.servicio.masajeDosValor = response.data.desgloce.precioMasajeDos
                            this.servicio.tarifaDinamicaDos = response.data.desgloce.precioDinamicaDos
                        }
                        this.confirmarProceso = true
                        if(this.servicio.tipo == 'doble' && this.servicio.busqueda == 'masajista'){
                            if(!this.servicio.masaje_dos){
                                this.confirmarProceso = false
                                this.masajistasDisponiblesDoble()
                            }else {
                                this.servicio.desplazamientoDos = response.data.desgloce.desplazamientoDos
                            }
                        }
                    }else if(response.data.code == 400){
                        // console.log(response.data)
                        this.error = true
                        this.errores = response.data.error
                        this.buttonurl = response.data.buttonurl
                        this.textbutton = response.data.textbutton
                        this.confirmarProceso = false
                    }
                })
            },
            masajistasDisponiblesDoble(){
                this.error = false
                this.errores = ''
                this.buttonurl = ''
                this.textbutton = ''
                var url = '/cliente/servicio/disponibilidad-manual-terapista-doble'
                axios.post(url, {
                    'direccion': this.servicio.datosDireccion.direccion,
                    'fecha': this.servicio.fecha,
                    'hora': this.servicio.hora,
                    'terapistaUno': this.servicio.terapistaUno.id,
                    'duracion': this.servicio.duracion
                }).then(response => {
                    if(response.data.code == 200){
                        this.terapistasDoble = response.data.terapistas
                    }
                    if(response.data.code == 400){
                        this.error = true
                        this.errores = response.data.error
                        this.buttonurl = response.data.buttonurl
                        this.textbutton = response.data.textbutton
                    }
                })
            },
            openProfile(id){
                EventBus.$emit('consultarPerfil', id);
            }
        },
        mounted() {
            // console.log('--- selección terapista component mounted ---')
            this.masajistasDisponibles()
        }
    };

</script>

<style>
.elegirMasajistaNombre {
    margin-bottom: 10px;
    text-shadow: 0px 0px 6px rgb(0 0 0 / 66%);
}

.elegirMasajistaBoton {
    margin-top: -75px;
    padding: 5px !important;
}

.el-carousel__arrow {
    background-color: rgb(18 59 90 / 50%);
}

.el-carousel__arrow:hover {
    background-color: rgb(18 59 90);
}

.vs-avatar-content.history--gradient:after{
    background-image: linear-gradient(40deg, #429eff 0%, #123b5a 100%) !important;
}
.selectExample {
    margin: 10px;
}
.perfilProBoton {
    position: absolute;
    top: 10px;
    margin-left: 200px;
    width: 50px;
    border-radius: 50%;
    height: 50px;
    font-size: 12px !important;
    line-height: 15px;
}
</style>